module.exports = __webpack_public_path__ + "fonts/Canada-Bold.36ea2b90f4b52b3b0ef2a410ea843cf1.woff2";